import { memo } from 'react';
import * as Icons from '@mui/icons-material';

export type IconNames = keyof typeof Icons;
export type IconProps = {
  icon: IconNames;
  className?: string;
  size?: 'inherit' | 'large' | 'medium' | 'small';
};

export const Icon = memo(({ icon, className, size = 'medium' }: IconProps) => {
  const MuiIcon = Icons[icon];

  if (!MuiIcon) {
    return null;
  }

  return <MuiIcon className={className} fontSize={size} />;
});
